module.exports = __webpack_public_path__ + "img/arrow.3bb437df.svg";